<template>
  <div data-testid="datepicker-root">
    <div @click.stop="dialog = true" data-testid="datepicker-input-wrapper">
      <v-text-field
        ref="element"
        type=""
        prepend-inner-icon="mdi-calendar-range"
        dense
        outlined
        :label="label || 'Date'"
        :clearable="clearable"
        :error-messages="error"
        class="noTransform"
        :value="formattedRangevalue"
        @keypress="dialog = true"
        @click:clear.stop="
          content = '';
          tempContent = '';
          updateValue();
        "
        :hide-details="hidedetails"
        :disabled="disabled"
        :placeholder="placeholder"
        data-testid="datepicker-textfield"
      ></v-text-field>
    </div>
    <v-dialog max-width="290px" v-model="dialog" transition="dialog-transition" data-testid="datepicker-dialog">
      <v-card>
        <v-card-text class="pa-0">
          <v-date-picker
            elevation="0"
            v-model="tempContent"
            color="tableHeaderBg black--text"
            class=""
            :min="min"
            :max="max"
            show-adjacent-months
            :type="type"
            :readonly="readonly"
            data-testid="datepicker-calendar"
          >
            <v-spacer></v-spacer>
            <v-btn text @click="dialog = false" class="secondaryBtn" data-testid="datepicker-close-btn"><span>Close</span></v-btn>
            <v-btn
              elevation="0"
              color="primary"
              @click="
                content = tempContent;
                dialog = false;
                updateValue();
              "
              data-testid="datepicker-ok-btn"
              ><span>Ok</span></v-btn
            >
          </v-date-picker>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// /* eslint-disable vue/multi-word-component-names */
export default {
  name: 'DatePicker',
  activated() {
    this.setValue();
    this.updateValue();
  },
  created() {
    // console.log(this.mindate);
    this.setValue();
    this.updateValue();
  },
  data: () => ({
    formattedvalue: "",
    dialog: false,
    content: "",
    tempContent: "",
  }),
  props: {
    error: {
      type: [String, Array],
    },
    label: {
      type: String,
    },
    value: {
      type: String,
    },
    min: {
      type: String,
      default: undefined,
    },
    max: {
      type: String,
      default: undefined,
    },
    type: {
      type: String,
      default: "date",
    },
    hidedetails: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly:{
      type: Boolean,
      default: false,
    },
    clearable:{
      type:Boolean,
      default: true,
    },
    placeholder:{
      type:String,
      default:''
    }
    // required: {
    //   type: Boolean,
    //   default: false
    // }
  },
  methods: {
    isValidRealisticDate: function (dateStr) {
      try {
        if (!dateStr) return false;
        
        // Check if date is valid using moment or Date
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return false;
        
        // Check if year is realistic (between 1900 and 2200)
        const year = date.getFullYear();
        if (year < 1900 || year > 2200) return false;
        
        return true;
      } catch (err) {
        return false;
      }
    },
    setValue: function () {
      const formattedDate = this.$nova.formatDateISO(this.value);
      
      // Only set content if date is valid and realistic
      if (this.isValidRealisticDate(formattedDate)) {
        this.content = formattedDate;
        this.tempContent = formattedDate;
      } else {
        this.content = "";
        this.tempContent = "";
      }
      
      this.updateValue();
    },
    updateValue: function () {
      this.$emit("input", this.content);
      this.$emit("change", this.content);
    },
    setFocus: function () {
      this.$nextTick(() => {
        this.$refs.element.$el.querySelector("input").focus();
      });
    },
    setBlank: function () {
      this.content = "";
      this.tempContent = "";
    },
  },
  computed: {
    formattedRangevalue() {
      // Return empty if content is not a valid realistic date
      if (!this.isValidRealisticDate(this.content)) {
        return "";
      }
      
      let format = undefined;
      if(this.type === "month") format = "MMM YYYY"
      let v = this.$nova.formatDate(this.content, format);
      if (v !== "" && v !== null && v !== undefined) return v;
      else {
        return "";
      }
    },
  },
  watch: {
    value: function () {
      this.setValue();
    },
    content: function (newVal) {
      // Validate content and clear if invalid
      if (newVal && !this.isValidRealisticDate(newVal)) {
        this.setBlank();
      }
    },
  },
};
</script>